// if (Config.ENV !== 'development') {
//   if (location.protocol !== 'https:') {
//     location.replace(location.href.replace('http', 'https'));
//   }
// }
import Vue from "vue";
import store from "./store";
import App from "./App.vue";
import router from "./router";
import Config from "./config";
import Api from "./api/api";
import ba from "vue-ba";
import { Toast } from "vant";

// import VConsole from 'vconsole';
// if (Config.ENV === 'development') {
//     let vConsole = new VConsole();
// }

Vue.config.productionTip = false;
Vue.prototype.$toast = Toast;
Vue.prototype.$store = store;
Vue.prototype.$config = Config;
Vue.prototype.$api = Api;
Vue.use(ba, "85e2f94e6b4bf02bf130ac1b905a649d");
Vue.use(ba, { siteId: "85e2f94e6b4bf02bf130ac1b905a649d" });

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
